// src/config.js

const productsConfig = [
  {
    productName: "Penny Drop",
    price: 5,
    creditName: "pennydrop",
    creditAPIUrl: "https://pennydrop.meon.co.in/get_credit",
    minQuantity: 20,
  },
  {
    productName: "Pan API",
    price: 1,
    creditName: "pan",
    creditAPIUrl: "https://panapi.meon.co.in/get_credit",
    minQuantity: 100,
  },
  {
    productName: "OCR",
    price: 2,
    creditName: "ocr",
    creditAPIUrl: "https://ocr.meon.co.in/get_credit_e",
    minQuantity: 50,
  },
  {
    productName: "Location Fetch",
    price: 2,
    creditName: "ocr",
    creditAPIUrl: "https://ocr.meon.co.in/get_credit_e",
    minQuantity: 50,
  },
  // {
  //     productName: "International API Suite",
  //     price: 2,
  //     creditName: "ocr",
  //     creditAPIUrl: "https://ocr.meon.co.in/get_credit_e",
  //     minQuantity: 25,
  // },
  {
    productName: "GST Verification",
    price: 2,
    creditName: "ocr",
    creditAPIUrl: "https://ocr.meon.co.in/get_credit_e",
    minQuantity: 50,
  },
  {
    productName: "e-Doc Retrieval",
    price: 2,
    creditName: "digilocker",
    creditAPIUrl: "https://digilocker.meon.co.in/digilocker/get_credit",
    minQuantity: 50,
  },
  {
    productName: "Passport Verification",
    price: 2,
    creditName: "digilocker",
    creditAPIUrl: "https://digilocker.meon.co.in/digilocker/get_credit",
    minQuantity: 50,
  },
  {
    productName: "Aadhaar Fetch",
    price: 2,
    creditName: "digilocker",
    creditAPIUrl: "https://digilocker.meon.co.in/digilocker/get_credit",
    minQuantity: 50,
  },
  {
    productName: "Driving License Fetch",
    price: 2,
    creditName: "digilocker",
    creditAPIUrl: "https://digilocker.meon.co.in/digilocker/get_credit",
    minQuantity: 50,
  },
  {
    productName: "Marksheet Fetch",
    price: 2,
    creditName: "digilocker",
    creditAPIUrl: "https://digilocker.meon.co.in/digilocker/get_credit",
    minQuantity: 50,
  },
  {
    productName: "Educational Documents Fetch",
    price: 2,
    creditName: "digilocker",
    creditAPIUrl: "https://digilocker.meon.co.in/digilocker/get_credit",
    minQuantity: 50,
  },
  {
    productName: "Vehicle RC Fetch",
    price: 2,
    creditName: "digilocker",
    creditAPIUrl: "https://digilocker.meon.co.in/digilocker/get_credit",
    minQuantity: 50,
  },
  {
    productName: "UAN Card Fetch",
    price: 2,
    creditName: "digilocker",
    creditAPIUrl: "https://digilocker.meon.co.in/digilocker/get_credit",
    minQuantity: 50,
  },
  {
    productName: "Income Certificate Fetch",
    price: 2,
    creditName: "digilocker",
    creditAPIUrl: "https://digilocker.meon.co.in/digilocker/get_credit",
    minQuantity: 50,
  },
  {
    productName: "Apaar Card Fetch",
    price: 2,
    creditName: "digilocker",
    creditAPIUrl: "https://digilocker.meon.co.in/digilocker/get_credit",
    minQuantity: 50,
  },
  {
    productName: "Insurance Fetch",
    price: 2,
    creditName: "digilocker",
    creditAPIUrl: "https://digilocker.meon.co.in/digilocker/get_credit",
    minQuantity: 50,
  },
  {
    productName: "Meon Face Verification",
    price: 5,
    creditName: "ipv",
    creditAPIUrl: "https://face-finder.meon.co.in/backend/get_credit",
    minQuantity: 20,
  },
  {
    productName: "eSign",
    price: 20,
    creditName: "esign",
    creditAPIUrl:
      "https://esign.meon.co.in/EsignServices/GetCreditForDeveloperTool",
    minQuantity: 5,
  },
];

export default productsConfig;
